import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth';

import SaveStepButton from './SaveStepButton';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import renderField from './renderField';

class SuretyForm extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_surety" description="Surety"/>
                        <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.setSurety)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name={`name`} autoComplete="off" component={renderField} type="text" label="Nombre y Apellido" />
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-12">
                                <div className="form-group">
                                    <Field className="form-control" name={`cuil`} autoComplete="off" component={renderField} type="cuil" label="Número de Cuil" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

SuretyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

SuretyForm = TopScrolleable(SuretyForm);

SuretyForm = reduxForm({
    form: 'SuretyForm', // a unique name for this form
})(SuretyForm);

SuretyForm = withAuthControl(SuretyForm);

export default SuretyForm;


/** WEBPACK FOOTER **
 ** ./src/components/SuretyForm.js
 **/